<template>
  <perfect-scrollbar>
    <CollapsibleList :items="bots"
                     v-model="openBots"
                     :selected-index="selectedBotIndex"
                     :is-selected="selectedBotIndex >= 0 && !isRenameMode && !selectedChannel"
    >
      <template #title="{item}">
        <SettingsBotsListTitle :bot="item"
                               :is-rename-mode="isRenameMode"
                               :is-selected="selectedBotIndex >= 0 && item.id === bots[selectedBotIndex].id"
                               @update:bot-name="$emit('update:bot-name', $event)"
                               @request-delete="$emit('request-delete', $event)"
                               @select-bot="handleBotSelect"
        />
      </template>

      <template #content="{item}">
        <SettingsBotsListChannel v-for="(channel, i) in item.channels"
                                 :key="channel.id"
                                 :channel="channel"
                                 :selected-channel="selectedChannel"
                                 :is-last="i === item.channels.length - 1"
                                 @select-channel="selectChannel(channel, i)"
        />
      </template>
    </CollapsibleList>
  </perfect-scrollbar>
</template>

<script>
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import SelectableTable from '@/components/common/SelectableTable.vue'
import ChannelTypeIcons from '@/components/analytics/filter/ChannelTypeIcons.vue'
import CollapsibleList from '@/components/common/CollapsibleList.vue'
import SettingsBotsListChannel from '@/components/settings/bots/SettingsBotsListChannel.vue'
import SettingsBotsListTitle from '@/components/settings/bots/SettingsBotsListTitle.vue'
import { ROUTE_NAMES } from '@/router'

export default {
  name: 'SettingsBotsList',

  components: {
    SettingsBotsListTitle,
    SettingsBotsListChannel,
    CollapsibleList,
    PerfectScrollbar,
    SelectableTable,
    ChannelTypeIcons
  },

  props: {
    selectedBotIndex: {
      type: Number,
      default: 0
    },
    bots: {
      type: Array,
      required: true
    },
    isRenameMode: {
      type: Boolean,
      default: false
    },
    selectedChannel: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      openBots: {}
    }
  },

  emits: ['update:bot-name', 'request-delete', 'select-channel-index', 'select-bot-index'],

  computed: {},

  watch: {
    selectedBotIndex: {
      immediate: true,
      handler(newIndex) {
        if (newIndex >= 0) {
          this.$set(this.openBots, newIndex, true)
        }
      }
    }
  },

  methods: {
    selectChannel(channel, channelIndex) {
      if (channel.id === this.selectedChannel?.id) return

      this.$emit('select-channel-index', channelIndex)
      const selectedBotIndex = this.bots.findIndex(bot => bot.channels.find(c => c.id === channel.id))
      const selectedBot = this.bots[selectedBotIndex]
      this.openBots[selectedBotIndex] = true
      this.$emit('select-bot-index', selectedBotIndex)
      this.$router.push({
        name: ROUTE_NAMES.botsWithChannel,
        params: {
          botId: selectedBot.id,
          channelId: channel.id
        }
      })
    },
    handleBotSelect(bot) {
      const selectedBotIndex = this.bots.findIndex(b => b.id === bot.id)
      this.$emit('select-bot-index', selectedBotIndex)
      this.openBots[selectedBotIndex] = true
      this.$router.push({
        name: ROUTE_NAMES.bots,
        params: {
          botId: bot.id
        }
      })
    }
  }
}
</script>

<style lang="scss">
#settings-bots-table {
  table {
    display: inline-block;

    tbody {
      max-height: 100% !important;

      & > div {
        max-height: 70vh !important;
      }

      .table-body-wrapper {
        height: 100% !important;
      }
    }
  }
}
</style>
